import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';
import {
  distanceQuantityField,
  distanceUnitField,
  flightRouteField,
  isCompanyOwnedOrLeasedField,
  tripKindField,
} from './common/travelFields';

export const travelPrivateJetsMetadata = {
  displayName: msg({
    message: 'Private air travel',
    context: 'Activity data schema name for private air travel',
  }),
  fields: {
    ...coreFields,
    ...vendorFields,
    distance_quantity: distanceQuantityField,
    // NOTE: quantity does not exist on the BAT but distance_quantity is
    // renamed to quantity in the BART-EM matching process
    quantity: distanceQuantityField,
    distance_unit: distanceUnitField,
    flight_route: flightRouteField,
    is_company_owned_or_leased: isCompanyOwnedOrLeasedField,
    private_plane_model: {
      displayName: msg({
        message: 'Private plane model',
        context: 'The private plane model',
      }),
      externalDescription: msg({
        message: 'The model of the private plane.',
        context: 'Plane model',
      }),
    },
    trip_kind: tripKindField,
  },
} as const satisfies BatMetadataConfigEntry;
